const getMiddleNameInitial = (middleName: string) => {
  return middleName ? ' ' + middleName[0] + '.' : '';
};

export default getMiddleNameInitial;
